const serverUrl = '/api/albums';
const serverUrlNew = '/api/albums-new';
const imgUrl = 'https://chi247.me/albums-covers/';

export { serverUrl, serverUrlNew, imgUrl };
